var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"PaB-button",class:_vm.buttonClasses,attrs:{"disabled":_vm.disabled}},[_vm._t("before"),(_vm.label)?_c('span',{staticClass:"button__text"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_vm._t("after")],2)}
var staticRenderFns = []

export { render, staticRenderFns }